import axios from 'axios';

export const RolesPermissionsService = {
  rolesPermissionsDetailsGET: (
    payload: {
      roleId: string;
      id: string;
      title: string;
    },
    source: any,
    itemId: string,
  ) =>
    axios.post<{
      title: string;
      data: {
        id: string;
        name: string;
        frontendId: string;
        mode: number;
      }[];
    }>(`/Roles`, payload, {
      cancelToken: new axios.CancelToken((c) => {
        if (itemId?.length) source.current[`${itemId}`] = c;
      }),
    }),
  updateMode: (payload: { frontEndId: string; roleId: string; mode: number }) =>
    axios.put<{
      id: string;
    }>(`/Roles`, payload),
  createNewRolePOST: (params: { roleName: string }) =>
    axios.post(`/Roles/AddNew`, null, { params }),
  cloneRolePOST: (params: { roleName: string; roleId: string }) =>
    axios.post(`/Roles/Clone`, null, { params }),
};
